var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-input',{attrs:{"type":"tel","maxLength":"20","pattern":/[^0-9\-\(\) ]/g,"value":_vm.value},on:{"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }